import Button from 'components/StyledButton/StyledButton';
import styled from 'styled-components';

const CustomGreenButton = styled(Button)<{variant: 'contained' | 'outlined'}>`
    background-color: ${({variant}) => variant === 'outlined' ? 'unset' : '#28a745'};
    border-color: #1e7e34;
    color: ${({variant}) => variant === 'outlined' ? '#1e7e34' : '#ffffff'};
    height: fit-content;
    margin: auto;
    &:hover {
        background-color: ${({variant}) => variant === 'outlined' ? 'unset' : '#218838'};
    }
`;

export default CustomGreenButton;
